export enum ResidualStatus {
  processing = 'Processing',
  imported = 'Imported',
  published = 'Published',
  readyForReview = 'Ready for review',
  failed = 'Failed',
  missingScheduleA = 'Missing Schedule A',
}
